import LabelService from '@/service/LabelService';
const labelService = new LabelService();
export default {
    namespaced: true,
    state() {
        return {
            labels: null,
            languages: null,
            formattedLabels: {},
        }
    },
    getters: {
        labels: state => {
            return state.labels
        },
        languages: state => {
            return state.languages
        },
        formattedLabels: state => {
            return state.formattedLabels
        },
    },
    mutations: {
        setLabels: function(state , payload) {
            state.labels = payload
        },
        setLanguages: function(state , payload) {
            state.languages = payload
        },
        setFormattedLabels: function(state , payload) {
            state.formattedLabels = payload;
        },
        stringToObj: function (state, payload) {
            var path = payload.key;
            var value = payload.value;
            var obj = payload.param;
            var parts = path.split("."), part;
            var last = parts.pop();
            // eslint-disable-next-line no-cond-assign
            while (part = parts.shift()) {
                if (typeof obj[part] != "object") obj[part] = {};
                obj = obj[part]; // update "pointer"
            }
            obj[last] = value;
        },
    },
    actions: {
        async getLabels(context, payload) {
            context.commit('loader/activeLoader', true, {root:true})
            let response = await labelService.getLabels(payload);
            context.commit("setLabels", response);
            context.dispatch("parserLabels");
            context.commit('loader/activeLoader', false, {root:true})
            return context.state.formattedLabels;
        },
        async getLanguages(context) {
            let response = await labelService.getLanguages();
            context.commit("setLanguages", response);
            return await response;
        },
        parserLabels: function (context) {
            context.state.labels.forEach((param) => {
                context.commit("stringToObj", { key: param.attributes.key, value: param.attributes.value, param: context.state.formattedLabels });
            });
        },
    }
};